<template>
<div class="aaConfirmOrder">
    <div v-if="init">
    <div class="tip" v-if="item.collectinfo.iscollectenrollinfo">
        <div class="content">需要填写所购票数对应的参加人信息</div>
    </div>
    <div class="activity-summary">
        <div class="left">
            <img class="img" v-lazy="item.eventinfo.coveratturl" alt="">
        </div>
        <div class="right">
            <div class="title">{{item.eventinfo.title}}</div>
            <div class="datatime">{{item.eventinfo.begintime}}-{{item.eventinfo.endtime }}</div>
            <div class="addr">{{item.eventinfo.address}}</div>
        </div>
    </div>
    <div class="ticket-detail">
        <div class="title">票种信息</div>
        <div class="ticket-summary">
            <div class="name">{{item.eventticketinfo.name}}</div>
            <div class="value">
                <span class="num" v-if="item.eventticketinfo.seasonticketcount>1">{{item.eventticketinfo.seasonticketcount}}人套票</span>
                <span class="subtotal">￥{{item.eventticketinfo.uprice}} x {{item.eventticketinfo.ticketcount}}</span>
            </div>
        </div>
    </div>
    <div class="signup-details">
        <div class="title"><span class="blod">报名信息</span><span v-if="item.collectinfo.iscollectenrollinfo">({{aaEnrollmentList.length}}/{{item.collectinfo.allticketcount}})</span></div>
        <div class="signup-summary" v-for="(obj,index) in aaEnrollmentList" :key="index">
            <div class="name">{{obj.joinername}}</div>
            <div class="tel">{{obj.joinermobile}}</div>
            <div class="del icon-aa-del" @click="delSignup(index)"></div>
        </div>
    </div>
    <div class="signup-btn" @click="enrollment" v-if="isEnrollment">
        <van-icon name="add-o" /><span>选择报名用户</span>
    </div>
    <div class="submit-btn">
        <div class="total"><span class="name">合计：</span><span class="value">￥{{item.eventticketinfo.allprice}}</span></div>
        <div class="btn" @click="submitOrder">提交订单</div>
    </div>
    <transition name="slide-sort">
        <aaEnrollment v-if="aaEnrollment" ref="aaEnrollment" :collectinfo="item.collectinfo" @closeEnrollment="closeEnrollment"></aaEnrollment>
    </transition>
    </div>
</div>
</template>

<script>
import {getConfirmOrderinfo, saveEventOrderInfo} from 'api/activeTools'
import {mapGetters, mapActions} from 'vuex'
import AaEnrollment from 'views/mapply/ticketPage/aaEnrollment.vue'
import $ from 'jquery'
export default {
    name: 'aaConfirmOrder',
    data() {
        return {
            item: {
                collectinfo: {
                    allticketcount: 0, // 添加的人数
                    iscollectenrollinfo: 1 // 是够开启名单收集
                },
                eventinfo: {
                    eventid: '',
                    address: '',
                    begintime: '',
                    coveratturl: '',
                    endtime: '',
                    title: ''
                },
                eventticketinfo: {
                    name: '',
                    seasonticketcount: 1, // 1单人票 大于1 套票
                    ticketid: '',
                    tickettype: 2,
                    tickettypename: '',
                    allprice: '',
                    uprice: ''
                }
            },
            param: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                ticketid: this.$route.query.ticketid ? this.$route.query.ticketid : '',
                ticketcount: this.$route.query.ticketcount ? this.$route.query.ticketcount : 0
            },
            init: false
        }
    },
    mounted() {
        document.title = '提交订单'
        // if (!this.isInit) {
        //     this._getView()
        // }
        this._getView()
    },
    activated() {
        if (this.isInit) {
            this.param.eventid = this.$route.query.eventid
            this.param.ticketid = this.$route.query.ticketid
            this.param.ticketcount = this.$route.query.ticketcount
            this.setAaEnrollmentList([])
            this._getView()
        }
        this.setIsInit(false)
    },
    methods: {
        enrollment() {
            this.setAaEnrollment(true)
            // this.$nextTick(() => {
            //     this.$refs.aaEnrollment.openDialog(this.item.collectinfo.allticketcount, this.item.collectinfo.iscollectenrollinfo)
            // })
        },
        closeEnrollment() {
            this.setAaEnrollment(false)
        },
        delSignup(index) {
            let arr = $.extend(true, [], this.aaEnrollmentList)
            arr.splice(index, 1)
            this.setAaEnrollmentList(arr)
        },
        submitOrder() {
            if (!this.isEnrollment) {
                let tmpList = []
                this.aaEnrollmentList.forEach(obj => {
                    tmpList.push({innerid: obj.joininerid})
                })
                let tmp = {
                    eventid: this.item.eventinfo.eventid,
                    ticketid: this.item.eventticketinfo.ticketid,
                    ticketnum: this.item.eventticketinfo.ticketcount,
                    ordermoney: this.item.eventticketinfo.allprice,
                    ticketuserjson: JSON.stringify(tmpList)
                }
                this._addOrder(tmp)
            } else {
                this.$toast.fail(`请选择${this.item.collectinfo.allticketcount}位报名用户`)
            }
        },
        _addOrder(tmp) {
            this.setLoading(true)
            saveEventOrderInfo({
                data: tmp,
                success: data => {
                    // 900提交成功(不审核不支付) 901提交成功(待审核) 902提交成功(待支付)
                    this.setLoading(false)
                    this.setAaEnrollmentList([])
                    let enrollcode = data.data.enrollcode
                    this.setIsInit(true)
                    if (enrollcode === 900) {
                        this.$router.push({name: 'AaPaymentResult', query: {orderid: data.data.orderno, result: 'Y', flag: 1}})
                    } else if (enrollcode === 901) {
                        this.$router.push({name: 'AaPaymentResult', query: {orderid: data.data.orderno, result: 'B', flag: 1}})
                    } else if (enrollcode === 902) {
                        window.location.href = data.data.payurl
                    } else {
                        let ispaysuccess = data.data.ispaysuccess
                        if (!ispaysuccess) {
                            window.location.href = data.data.payurl
                        } else if (ispaysuccess === 1) {
                            this.$router.push({name: 'AaPaymentResult', query: {orderid: data.data.orderno, result: 'Y', flag: 1}})
                        } else if (ispaysuccess === 2) {
                          // status 1待审核  9待支付
                            if (data.data.status === 1) {
                                this.$dialog.confirm({
                                    title: '提示',
                                    confirmButtonText: '查看订单',
                                    cancelButtonText: '暂不取消',
                                    message: '您当前有待审核的订单，如需重新下单请先取消该订单？'
                                }).then(() => {
                                    // this.$router.push({name: 'myTicket', query: {eventid: this.param.eventid}})
                                  this.setRefresh(true)
                                  this.$router.push({name: 'MOrderList'})
                                }).catch(() => {
                                })
                            } else if (data.data.status === 9) {
                                this.$dialog.confirm({
                                    title: '提示',
                                    confirmButtonText: '查看订单',
                                    cancelButtonText: '再想想',
                                    message: '您当前有待支付的订单，请尽快完成支付！'
                                }).then(() => {
                                  // this.$router.push({name: 'myTicket', query: {eventid: this.param.eventid}})
                                  this.setRefresh(true)
                                  this.$router.push({name: 'MOrderList'})
                                }).catch(() => {})
                            }
                        }
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getConfirmOrderinfo({
                data: this.param,
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                    this.init = true
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setAaEnrollment',
            'setAaEnrollmentList',
            'setIsInit',
          'setRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        isEnrollment() {
            if (this.item.collectinfo.iscollectenrollinfo && this.aaEnrollmentList.length < this.item.collectinfo.allticketcount) {
                return true
            } else if (!this.item.collectinfo.iscollectenrollinfo && this.aaEnrollmentList.length < 1) {
                return true
            } else {
                return false
            }
        },
        ...mapGetters([
            'aaEnrollment',
            'isInit',
            'aaEnrollmentList'
        ])
    },
    components: {
        AaEnrollment
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.aaConfirmOrder {
    position: relative;
    padding-bottom: 1.1rem;
    height: 100vh;
    box-sizing: border-box;
    overflow: auto;
    .tip{
        height: 0.56rem;
        .content{
            color: #DE962F;
            font-size: 0.24rem;
            background: #FFF7EC;
            padding: 0 0.32rem;
            height: 0.56rem;
            line-height: 0.56rem;
            position: fixed;
            top:0;
            left: 0;
            right: 0;
        }
    }
    .activity-summary{
        padding: 0.4rem 0.32rem;
        @include flexBox(space-between);
        background: #fff;
        overflow: hidden;
        .left{
            margin-right: 0.15rem;
            width: 2.8rem;
            min-width: 2.8rem;
            height: 1.6rem;
            @include flexBox(center);
            .img{
                width: 100%;
                height: 100%;
                border-radius: 0.1rem;
            }
        }
        .right{
            flex-grow: 1;
            height: 1.68rem;
            .title{
                font-size: 0.26rem;
                color: #303133;
                font-weight: 600;
                line-height: 0.36rem;
            }
            .datatime,.addr{
                margin-top: 0.08rem;
                font-size: 0.2rem;
                color:  #666666;
            }
        }
    }
    .ticket-detail{
        margin-top: 0.24rem;
        background: #fff;
        padding: 0.32rem;
        .title{
            color: #333333;
            font-size: 0.28rem;
            font-weight: 600;
        }
        .ticket-summary{
            margin-top: 0.32rem;
            color: #333333;
            font-size: 0.3rem;
            @include flexBox(space-between);
            .value{
                .num{
                    font-size: 0.2rem;
                    color: #999999;
                    margin-right: 0.32rem;
                }
                .subtotal{
                }
            }
        }
    }
    .signup-details{
        margin-top: 0.24rem;
        padding: 0.32rem;
        background: #fff;
        color:  #333333 ;
        .title{
            font-size: 0.28rem;
            font-weight: 600;
        }
        .signup-summary{
            margin-top: 0.32rem;
            font-size: 0.3rem;
            @include flexBox(space-between);
            .name{
                width: 1.5rem;
                max-width: 1.5rem;
                min-width: 1.5rem;
                margin-right: 1rem;
            }
            .del{
                flex-grow: 1;
                text-align: right;
                &:before{
                    width: 0.4rem;
                    height: 0.4rem;
                }
            }
        }
    }
    .signup-btn{
        margin-top: 0.24rem;
        background: #fff;
        color: #0ABF53;
        font-size: 0.28rem;
        height: 1rem;
        @include flexBox(center);
        .van-icon{
            font-size: 0.32rem;
            margin-right: 0.12rem;
        }
    }
    .submit-btn{
        position: fixed;
        bottom:0;
        left: 0;
        right: 0;
        height: 1.1rem;
        padding: 0 0.32rem;
        font-size: 0.28rem;
        @include flexBox(space-between);
        background: #fff;
        box-shadow:2px 0px 4px 0px rgba(0,0,0,0.1);
        .total{
            .name{
                color:  #666666 ;
            }
            .value{
                color: #FF4747;
            }
        }
        .btn{
            background:linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
            border-radius:0.4rem;
            width: 4.42rem;
            height: 0.76rem;
            color: #fff;
            font-size: 0.32rem;
            text-align: center;
            line-height: 0.76rem;
        }
    }
    .slide-sort-enter-active, .slide-sort-leave-active{
        transition: all 0.3s
    }
    .slide-sort-enter, .slide-sort-leave-to{
        transform: translate3d(100%, 0, 0)
    }
}
</style>
